import { createReducer } from '../../../utils';

import constants from '../constants';

import moment from 'moment';
import { fromJS } from 'immutable';
import { composeResetReducer } from 'redux-reset-store';

const initialState = {
    selectedReceipts: [],
    types: ['all', 'rearrangement', 'stocktaking', 'price_change', 'customer_order', 'retour'],
    filterByType: 'stocktaking',
    from: moment().subtract(3, 'days'),
    to: moment().endOf('day'),
    isFetching: false,
    didInvalidate: false,
    selectedUser: '-1',
    selectedBranch: '-1',
    items: [],
};

function requestReceipts(state) {
    return state.merge({ isFetching: true, didInvalidate: false });
}

function receiveReceipts(state, playload) {
    return state.merge({
        isFetching: false,
        didInvalidate: false,
        items: fromJS(playload.receipts),
    });
}

function changeFromFilter(state, playload) {
    return state.merge({ from: playload.from });
}

function changeToFilter(state, playload) {
    return state.merge({ to: playload.to });
}

function changeReceiptFilterType(state, playload) {
    return state.merge({ filterByType: playload.filterByType, selectedReceipts: fromJS([]) });
}

function changeReceiptFilterUser(state, playload) {
    return state.merge({ selectedUser: playload.user });
}

function changeReceiptFilterBranch(state, playload) {
    return state.merge({ selectedBranch: playload.branch });
}

function changeSelectedReceipts(state, payload) {
    if (payload.selected_receipts.length === 1 && payload.select_branch == true) {
        const receipt = state.get('items').find(r => r.get('id') == payload.selected_receipts[0]);
        return state.merge({
            selectedReceipts: fromJS(payload.selected_receipts),
            selectedBranch: receipt.get('branch'),
        });
    } else {
        return state.merge({
            selectDuplicates: payload.select_duplicates,
            selectPrinted: payload.select_printed,
            selectedReceipts: fromJS(payload.selected_receipts),
        });
    }
}

function setProfile(state, playload) {
    return state.merge({ file: playload });
}

export default composeResetReducer(
    createReducer(fromJS(initialState), {
        [constants.RECEIPTS_REQUEST]: requestReceipts,
        [constants.RECEIVE_RECEIPTS]: receiveReceipts,
        [constants.RECEIPT_FROM_FILTER_CHANGE]: changeFromFilter,
        [constants.RECEIPT_TO_FILTER_CHANGE]: changeToFilter,
        [constants.RECEIPT_FILTER_TYPE_CHANGE]: changeReceiptFilterType,
        [constants.RECEIPT_FILTER_USER_CHANGE]: changeReceiptFilterUser,
        [constants.RECEIPT_FILTER_BRANCH_CHANGE]: changeReceiptFilterBranch,
        [constants.SELECTED_RECEIPTS_CHANGE]: changeSelectedReceipts,
    }),
    fromJS(initialState),
    'AUTH_LOGOUTUSER_REQUEST'
);
